import State from "slotworks/state-machine/states/state";
import JackpotComponent from "components/jackpot/jackpot-component";
import Layers from "slotworks/graphics/layers/layers";
import RainbowStacksRespinRecord from "integration/revolver/schema/respin-record";
import gameState from "slotworks/model/game-state";
import getJackpotTypeFromSymbol from "util/jackpot";
import Components from "slotworks/components/components";
import deviceInfo from "slotworks/utils/device-info";
import betModel from "slotworks/model/bets/bet-model";
import soundManager from "slotworks/sound/sound-manager";
import autoplayModel from "slotworks/model/autoplay-model";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";

export default class JackpotState extends State {

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord() as RainbowStacksRespinRecord;
        const bet = betModel.getTotalBet();
        let startAmount = 0;
        for(const multiplier of record.awardedAmounts) {
            startAmount += multiplier * bet;
        }

        const jackpot = new JackpotComponent();
        jackpot.start(record.creditsWon, startAmount, getJackpotTypeFromSymbol(record)).then(() => {
            jackpot.end();
            if(!deviceInfo.isDesktop) {
                Layers.Custom.get("Messages")?.defaultScene().execute();
            }
            Components.betBar.setEnabled(true);
            Layers.BetBar.show();
            Layers.SmartButton.show();

            let win;
            if(gameState.getCurrentGame().inFreespinsGame) {
                win = gameState.getCurrentGame().getRunningFreespinsWinTotal();
            } else {
                win = gameState.getCurrentGame().totalCreditsWon;
            }
            Components.betBar.winnings.setWinnings(win, win, 750);

            if (autoplayModel.isAutoPlaying() && autoplayModel.stopOnJackpotWin) {
                StopAutoplayCommand();
            }
            
            this.complete();
        })
    }

    public onExit() {
        if(gameState.getCurrentGame().inFreespinsGame) {
            soundManager.customEvent("freespins_music");
        } else {
            soundManager.customEvent("base_music");
        }
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/jackpot.ts